import React from "react";

function MobileApp2Svg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
      fill={color}
    >
      <g>
        <path
          d="M332.5 374.7V391c0 15.4-12.6 28-28 28H88c-15.4 0-28-12.6-28-28V58c0-15.4 12.6-28 28-28h216.5c15.4 0 28 12.6 28 28v16.8c4.6-.4 9.3-.7 14-.7 5.3 0 10.7.3 16 .8V58c0-32-26-58-58-58H88C56 0 30 26 30 58v396c0 32 26 58 58 58h216.5c32 0 58-26 58-58v-79.5c-5.3.6-10.7.9-16 .9-4.8 0-9.4-.3-14-.7zM219.4 482H173c-9.2-.2-16.4-7.8-16.2-17 .2-8.8 7.3-16 16.2-16.2h46.5c9.2-.2 16.8 7 17 16.2s-7 16.8-16.2 17h-.9z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
        <path
          d="M346.5 89.2c-74.9 0-135.6 60.7-135.6 135.6s60.7 135.6 135.6 135.6S482 299.6 482 224.8c0-74.9-60.7-135.6-135.5-135.6zm77 116.6L343.3 286c-9.6 9.6-25.1 9.6-34.6 0l-44.2-44.2c-9.4-9.7-9.2-25.2.5-34.6 9.5-9.3 24.7-9.3 34.2 0L326 234l62.8-62.9c9.6-9.6 25.1-9.6 34.7 0 9.5 9.6 9.5 25.1 0 34.7z"
          fill={color}
          opacity="1"
          data-original={color}
        ></path>
      </g>
    </svg>
  );
}

export default MobileApp2Svg;
